import { render, staticRenderFns } from "./NoOrganization.vue?vue&type=template&id=503b3690&"
import script from "./NoOrganization.vue?vue&type=script&lang=js&"
export * from "./NoOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports